<template>
<div class="chapter">
<div class="inner_page">
<h1 class="p_heading_" id="auto_bookmark_toc_1"><span class="calibre1">Blue</span></h1>
<p class="p_normal"> </p>
<p class="p_norm-noindent">By B.G. Thomas</p>
<p class="p_normal"> </p>
<p class="p_normal">Blue McCoy has lived on the streets for a long time, surviving by his wits and doing what he must, and he’s not above using his youthful appearance and air of innocence to his advantage. It’s not an easy life, but he’s happy. He has everything he really needs: the clothes on his back, a house to squat in, a sweet dog. Everything except that special someone to love him.</p>
<p class="p_normal">Six months ago, John Williams’s wife left him because she was bored. “Even your <span class="calibre2">name</span> is boring” were her last words to him before she walked out. Now he’s by himself in a big house, trying to figure out what direction his life should take. He’s never been so alone.</p>
<p class="p_normal">A chance encounter sets John on a new path, a path that becomes clearer when loneliness sends him to a local animal shelter to get a dog—and he finds an angel instead. An angel named Blue. A crisis brings them together, but it is something else that keeps them there. Could it be love? A love that can forever end two men’s deep loneliness and bring them the support and sense of belonging they’ve searched for all their lives?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?dea4e886